/** Same key as legacy cookie name; value must be non-empty to enable client debug logging. */
export const BV_TRACKING_DEBUG_KEY = 'bv_tracking_debug';
